import Immutable from 'immutable'

import calculateTreeLines from './calculateTreeLines'

export default function indexTree(nodes) {
  const recursion = (parent, nodes, firstIndexGlobal, level) => {
    const newNodes = nodes.reduce(
      ({ indexGlobal, nodes }, node, indexLocal) => {
        const [currentChildren, totalChildrenCount] = recursion(node, node.get('children'), indexGlobal + 1, level + 1)
        const newNode = node.withMutations((n) =>
          n
            .set('__parentId', parent ? parent.get('id') : undefined)
            .set('__indexGlobal', indexGlobal)
            .set('__indexLocal', indexLocal)
            .set('__level', level)
            .set('__totalChildrenCount', totalChildrenCount)
            .set('children', currentChildren),
        )
        return {
          indexGlobal: indexGlobal + totalChildrenCount + 1,
          nodes: nodes.concat([newNode]),
        }
      },
      { indexGlobal: firstIndexGlobal, nodes: Immutable.fromJS([]) },
    ).nodes

    const totalChildrenCount = newNodes.reduce((sum, n) => sum + n.get('__totalChildrenCount') + 1, 0)
    return [newNodes, totalChildrenCount]
  }

  return calculateTreeLines(recursion(undefined, nodes, 0, 0)[0])
}
